const pagesOrganizationEn = {
  chartPage: {
    emptyState: {
      description: 'No valid organization data exists for the specified date.',
      noFilterResultsDescription: 'No organization units match the current search. Try a different name or code.',
      noFilterResultsTitle: 'No matching organization units',
      title: 'No organization data available'
    },
    export: {
      error: 'Failed to export PDF',
      generating_pdf: 'Generating PDF...',
      success: 'PDF export completed',
      successDescription: 'The organization chart has been exported as a PDF.'
    },
    hierarchyView: {
      collapseMembers: 'Collapse members',
      expandMembers: 'Expand members',
      noMembers: 'No members'
    },
    tableView: {
      addedMembers: 'Added',
      loading: 'Loading...',
      members: 'Members',
      noMembers: 'No members',
      removedMembers: 'Removed'
    },
    totalMemberCount: {
      totalCount: 'total {{count}}'
    },
    treeView: {
      collapseMembers: 'Collapse members',
      countPeople: 'people',
      expandMembers: 'Expand members',
      layerCollapseSubtree: 'Collapse all units below this layer',
      layerExpandSubtree: 'Expand all units below this layer',
      noMembers: 'No members'
    }
  },
  components: {
    adjacentDepartments: {
      childDepartment: 'Child Department',
      parentDepartment: 'Parent Department'
    },
    header: {
      countPeople: 'people',
      level: 'Level',
      noOrganizationInfo: 'Organization information not found'
    },
    organizationToolbar: {
      compactView: 'Compact View',
      export: 'Export',
      hierarchy: 'Hierarchy',
      jumpNoResults: 'No matching units',
      jumpToOrgUnit: 'Jump to org unit',
      miniMap: 'Mini map',
      mode: 'view',
      searchPlaceholder: 'Filter by name or code',
      table: 'Table',
      tree: 'Tree'
    },
    structureCard: {
      childOrganizationUnit: 'Child Organization Unit',
      parentOrganizationUnit: 'Parent Organization Unit'
    }
  },
  detailPage: {
    headerTabs: {
      detail: 'Detail',
      history: 'History'
    },
    people: 'People',
    peopleCardFilter: {
      all: 'All',
      allEmploymentTypes: 'All Employment Types',
      employmentType: 'Employment Type',
      filterByName: 'Filter by name...'
    },
    statusBadge: {
      active: 'Active',
      inactive: 'Inactive'
    },
    structure: 'Structure'
  },
  organization: 'Organization',
  plan: {
    addOrEditOrgUnit: {
      addTitle: 'Add Organization Unit',
      editTitle: 'Edit Organization Unit',
      step1AddingProcess: {
        abolishSourceOrganizationUnit: 'Abolish the source organization unit',
        establishNewByDuplicating: 'Establish a new organization unit by duplicating data from an existing organization unit',
        establishNewByDuplicatingDescription: 'Duplicate the data of the source organizational unit to establish a new organization unit. Its history and organization unit IDs will not be carried over. This adding process is useful when launching a new organization unit if a similar organization unit exists.',
        establishNewFromScratch: 'Establish a new organization unit from scratch',
        sourceOrganizationUnit: 'The source organization unit',
        title: 'Adding Process'
      },
      step1UpdateProcess: {
        abolish: 'Abolish',
        abolishDescription: 'This will remove the selected organization unit from the organization. It will remain as a abolished organization unit, so the data in the system will not be lost.',
        title: 'Editing Process',
        transfer: 'Transfer',
        transferDescription: 'The new organization unit inherits all data from the selected organization unit. Since the ID of the organizational unit does not change, the history will also be carried over.'
      },
      step2OrgUnitName: {
        businessCardName: 'Business Card Name',
        name: 'Name',
        shortName: 'Short Name',
        title: 'Organization Unit Name'
      },
      step3OrgUnitInfo: {
        code: 'Code',
        office: 'Office',
        title: 'Organization Unit Info'
      },
      step4PurposeRole: {
        description: 'Description',
        functionalRole: 'Functional Role',
        mission: 'Mission',
        title: 'Purpose & Role'
      },
      step5Structure: {
        addChildOrganizationUnit: 'Add Child Organization Unit',
        childOrganizationUnit: 'Child Organization Unit',
        hierarchyLevel: 'Hierarchy Level',
        orderInHierarchy: 'Display Order',
        parentOrganizationUnit: 'Parent Organization Unit',
        title: 'Structure'
      },
      step6People: {
        addPerson: 'Add Person',
        addPosition: 'Add Position',
        addUnit: 'Add organization unit',
        assignedBy: 'Assigned By',
        departmentHead: 'Department Head',
        deputyHead: 'Deputy Head',
        noPerson: 'No Person',
        organizationUnitPersonnel: 'Organization Unit Personnel',
        organizationUnitRole: 'Organization Unit Role',
        peopleIncluded: 'people included',
        pleaseSelect: 'Please select the main organizational unit this user belongs to.',
        pleaseSelectPosition: 'Please select the position this member belongs to.',
        representativeType: 'Representative Type',
        roleName: 'Role Name',
        setPrimary: 'Set Primary Organization Unit',
        title: 'People'
      },
      unitSearchPlaceholder: 'Search by organization unit name'
    },
    baseDateWarning: {
      item: '{{name}} (effective {{applyPlanDate}})',
      title: 'The following confirmed plans, scheduled to apply after the base date, will not be reflected when this plan is applied.'
    },
    cantEditBecauseConfirmed: 'This plan has been confirmed and cannot be edited.',
    components: {
      statusBadge: {
        approved: 'Confirmed',
        archived: 'Archived',
        inProgress: 'Draft'
      }
    },
    create: {
      organizationPlanInfoStep: {
        baseDate: 'Base Date',
        baseDateDescription: 'An organization restructuring plan will be created based on the organization structure as of this date. It cannot be changed after the plan is created.',
        effectiveDate: 'Effective Date',
        effectiveDateDescription: 'Please select an effective date on or after the base date.',
        name: 'Name',
        title: '1. Organization Plan Info'
      },
      steps: {
        organizationPlanInfo: 'Organization Plan Info'
      },
      title: 'Create Organization Plan'
    },
    detailPage: {
      addOrganizationUnit: 'Add organization unit',
      baseDate: 'Base Date',
      completeDialog: {
        description: 'This operation cannot be undone. Are you sure you want to confirm?'
      },
      confirmed: 'Confirmed',
      draft: 'Draft',
      editDialog: {
        baseDate: 'Base Date',
        baseDateImmutable: 'The base date cannot be changed after the plan is created.',
        effectiveDate: 'Effective Date',
        effectiveDateDescription: 'Please select an effective date on or after the base date.',
        name: 'Name',
        title: 'Organization Plan Info'
      },
      effectiveDate: 'Effective Date',
      tabs: {
        organizationUnit: 'Organization Unit',
        settings: 'Settings',
        transfers: 'Transfers'
      },
      transfers: {
        filterJobLevel: 'Job Level',
        filterJobType: 'Job Type',
        filterOrganization: 'Organization',
        filterPosition: 'Position',
        primaryBadge: 'Primary',
        searchPlaceholder: 'Search by name...'
      }
    },
    driftConfirmDialog: {
      impact: {
        departmentRetired: 'Confirming removes {{changeCount}} department assignments.',
        primaryCleared: '{{personCount}} people will have their primary assignment cleared and will need it set again.'
      },
      impactTitle: 'Impact of confirming',
      incomplete: {
        description: 'Only part of the list could be shown and {{remainingCount}} changes cannot be reviewed. Confirmation is blocked so that unreviewed changes are not approved. Please contact support.',
        title: 'Too many changes to confirm'
      },
      irreversible: 'This action cannot be undone. Review the details before continuing.',
      summary: '{{changeCount}} department assignments changed outside this plan after it was created (joined: {{inflowCount}}, left: {{outflowCount}}).',
      title: 'Confirm {{name}}?'
    },
    driftWarning: {
      description: 'Joined: {{inflowCount}}, left: {{outflowCount}}. These changes do not appear in the Transfers tab.',
      impact: {
        departmentRetired: 'Confirming removes this person from this department',
        placedByPlan: 'Confirming restores the assignment defined by the plan',
        primaryWillBeCleared: 'The primary assignment will be cleared and must be set again'
      },
      kind: {
        inflow: 'Joined',
        outflow: 'Left'
      },
      notShown: '{{remainingCount}} more not shown.',
      title: '{{changeCount}} department assignments changed outside this plan'
    },
    emptyState: {
      createOrganizationPlan: 'Create organization plan',
      noOrganizationPlans: 'No organization plans'
    },
    tabs: {
      plan: 'Plan'
    },
    title: 'Organization Planning'
  },
  settingPage: {
    hierarchySetting: {
      actions: {
        delete: 'Delete',
        edit: 'Edit'
      },
      addHierarchy: 'Add Hierarchy Level',
      deleteHierarchyDialog: {
        cancel: 'Cancel',
        confirm: 'Delete',
        description: 'Are you sure you want to delete this hierarchy level? This action cannot be undone.',
        success: 'Hierarchy level deleted successfully',
        title: 'Delete Hierarchy Level'
      },
      description: 'The position of an organizational unit within the hierarchy is defined by its level value. A lower hierarchy level value corresponds to a higher-ranking organizational unit.',
      editHierarchyDialog: {
        addConfirm: 'Add',
        addDescription: 'Add a new hierarchy level. Please enter the hierarchy name.',
        addTitle: 'Add Hierarchy Level',
        cancel: 'Cancel',
        confirm: 'Edit',
        description: 'Are you sure you want to edit this hierarchy level? This action cannot be undone.',
        editConfirm: 'Save',
        editDescription: 'Are you sure you want to edit this hierarchy level? This action cannot be undone.',
        editTitle: 'Edit Hierarchy Level',
        label: 'Level Name',
        level: 'Hierarchy Level',
        placeholder: 'Enter the name of the hierarchy level',
        success: 'Hierarchy level edited successfully',
        title: 'Edit Hierarchy Level'
      },
      headers: {
        label: 'Level Name',
        level: 'Hierarchy Level'
      },
      subTitle: 'Level Settings',
      title: 'Hierarchy Level'
    }
  },
  tabs: {
    alert: 'Alert',
    chart: 'Chart',
    cost: 'Cost',
    history: 'History',
    overview: 'Overview',
    rulePolicy: 'Rule & Policy',
    settings: 'Settings'
  }
};
export default pagesOrganizationEn;